"use strict";

exports.__esModule = true;
exports.Click = void 0;

var _basic = require("./basic.js");

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _createForOfIteratorHelperLoose(o) { var i = 0; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } i = o[Symbol.iterator](); return i.next.bind(i); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _defaults(subClass, superClass); }

var CLICK_EVENTS = ['mousedown', 'touchstart'];
/**
 * Enter animation after icon click.
 */

var Click = /*#__PURE__*/function (_Basic) {
  _inheritsLoose(Click, _Basic);

  function Click() {
    return _Basic.apply(this, arguments) || this;
  }

  var _proto = Click.prototype;

  _proto.connectedCallback = function connectedCallback() {
    _Basic.prototype.connectedCallback.call(this);

    for (var _iterator = _createForOfIteratorHelperLoose(CLICK_EVENTS), _step; !(_step = _iterator()).done;) {
      var event = _step.value;
      var options = event === 'touchstart' ? {
        passive: true
      } : undefined;
      this.target.addEventListener(event, this.enterBound, options);
    }
  };

  _proto.disconnectedCallback = function disconnectedCallback() {
    for (var _iterator2 = _createForOfIteratorHelperLoose(CLICK_EVENTS), _step2; !(_step2 = _iterator2()).done;) {
      var event = _step2.value;
      this.target.removeEventListener(event, this.enterBound);
    }

    _Basic.prototype.disconnectedCallback.call(this);
  };

  _proto.enter = function enter() {
    if (!this.inAnimation) {
      this.playFromBegining();
    }
  };

  return Click;
}(_basic.Basic);

exports.Click = Click;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hbmltYXRpb25zL2NsaWNrLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUE7Ozs7Ozs7Ozs7OztBQUVBLElBQU0sWUFBWSxHQUFHLENBQUUsV0FBRixFQUFlLFlBQWYsQ0FBckI7QUFFQTs7OztJQUdhLEs7Ozs7Ozs7OztTQUNULGlCLEdBQUEsNkJBQWlCO0FBQ2IscUJBQU0saUJBQU47O0FBRUEseURBQW9CLFlBQXBCLHdDQUFrQztBQUFBLFVBQXZCLEtBQXVCO0FBQzlCLFVBQU0sT0FBTyxHQUFHLEtBQUssS0FBSyxZQUFWLEdBQXlCO0FBQUUsUUFBQSxPQUFPLEVBQUU7QUFBWCxPQUF6QixHQUE2QyxTQUE3RDtBQUNBLFdBQUssTUFBTCxDQUFZLGdCQUFaLENBQTZCLEtBQTdCLEVBQW9DLEtBQUssVUFBekMsRUFBcUQsT0FBckQ7QUFDSDtBQUNKLEc7O1NBRUQsb0IsR0FBQSxnQ0FBb0I7QUFDaEIsMERBQW9CLFlBQXBCLDJDQUFrQztBQUFBLFVBQXZCLEtBQXVCO0FBQzlCLFdBQUssTUFBTCxDQUFZLG1CQUFaLENBQWdDLEtBQWhDLEVBQXVDLEtBQUssVUFBNUM7QUFDSDs7QUFFRCxxQkFBTSxvQkFBTjtBQUNILEc7O1NBRUQsSyxHQUFBLGlCQUFLO0FBQ0QsUUFBSSxDQUFDLEtBQUssV0FBVixFQUF1QjtBQUNuQixXQUFLLGdCQUFMO0FBQ0g7QUFDSixHOzs7RUF0QnNCLFkiLCJzb3VyY2VSb290IjoiIn0=